export default __webpack_public_path__ + "static/metaverse-72e714a7189945a3a574a2b01a136cbf.png";